import { useLayoutEffect, useRef } from 'react';
import ContentLoader from 'react-content-loader';

const JobNotebookLoader = () => {
  const topElementRef = useRef(null);
  const sideElementRef = useRef(null);
  const mainElementRef = useRef(null);

  useLayoutEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      for (const _ of entries) {
        const loader = document.getElementById('jobNotebookLoader');
        topElementRef.current.setAttribute('width', loader.width.baseVal.value);
        sideElementRef.current.setAttribute('height', loader.height.baseVal.value - 50);
        mainElementRef.current.setAttribute('width', loader.width.baseVal.value - 205);
        mainElementRef.current.setAttribute('height', loader.height.baseVal.value - 50);
      }
    });
    resizeObserver.observe(document.getElementById('jobNotebookLoader'));

    return () => {
      resizeObserver.disconnect(); // Disconnect the observer when component unmounts
    };
  }, []);

  return (
    <ContentLoader
      id="jobNotebookLoader"
      backgroundColor="rgba(0,96,250, 0.1)"
      foregroundColor="rgba(204,116,245, 0.3)"
      width="100%"
      style={{ height: 'calc(100% - 2px)', overflowY: 'hidden' }}
    >
      <rect ref={topElementRef} x="0" y="0" rx="3" ry="3" width="100%" height="45" />
      <rect ref={sideElementRef} x="0" y="50" rx="3" ry="3" width="300" style={{ height: 'calc(100% - 50px)' }} />
      <rect ref={mainElementRef} x="305" y="50" rx="3" ry="3" style={{ width: 'calc(100% - 305px)', height: 'calc(100% - 50px)' }} />
    </ContentLoader>
  );
};

export default JobNotebookLoader;
